import React from "react";

export default function ProfileButton({label, disabled, onClick}) {
    return (
        <div className="col-12">
            <button className={"btn btn-outline-secondary"} disabled={disabled} onClick={onClick}>{label}</button>
            <br/><br/><br/>
        </div>
    )
}